
import { useState, useRef } from "react";
import Config from "../Config";
import InputComboGrupa from "./InputComboGrupa";
import InputTextAlpha from "./InputTextAlpha";
import InputComboStawkiWyzMulti from "./InputComboStawkiWyzMulti";
import InputCombo from "./InputCombo";
import InputComboGrupaE from "./InputComboGrupaE";




function InputKidsMulti(props)
{

    const [filterParam, setFilterParam] = useState({
        imie: props.mainView.readFilter('imie',''), 
        nazwisko:  props.mainView.readFilter('nazwisko',''),  
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 

       
    });


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    var max = 1000;
    if(props.max != undefined && props.max != null) max = props.max;

    const [maxKids,setMaxKids] = useState(max);

    const [tabSelected, setTabSelected] = useState(props.tabSelected);


    const [view, setView] = useState('btn');


    const getTab = () => {
            
        
        props.mainView.setProgress(-2);

    

        fetch( Config.url + '/rest_v1_employessModule,kids', {
            method: 'POST', 
            body: '', 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {                                              
                        setTab(res.result);                                         
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }


    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn'); 
    } 


    const saveData = () => {


        var selected = new Array();

        for(var g=0; g < tab.length; g++)
            {                
                    for(var d=0; d < tab[g].dzieci.length; d++)
                        {
                                
                              if(tab[g].dzieci[d].param1 == '1')  {  

                                selected.push( tab[g].dzieci[d] );
                              };
                               
                        }   
                
            }

            setTabSelected(selected);
            changeView();

            if(props.onKidsSelected != undefined) props.onKidsSelected(selected);

    }


    const goSelect = (e) => {

        var p_grupa_id = e.target.getAttribute('p_grupa_id');
        var p_dziecko_id = e.target.getAttribute('p_dziecko_id');

        //console.log(p_grupa_id, p_dziecko_id);

        for(var g=0; g < tab.length; g++)
        {
            if(tab[g].id == p_grupa_id )
            {
                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                            if(tab[g].dzieci[d].id == p_dziecko_id )
                            {
                                if(tab[g].dzieci[d].param1 == '0')  {  tab[g].dzieci[d].param1 = '1' } else tab[g].dzieci[d].param1 = '0' ;
                            }else
                            {
                                if(maxKids == 1)    tab[g].dzieci[d].param1 = '0' ;
                            }
                    }   
            }else 
            if(maxKids == 1) {

                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                         tab[g].dzieci[d].param1 = '0' ;
                    } 
            }


        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));

    }


    const selectAll = (e) =>  {


        if(maxKids == 1) return;

        var p_grupa_id = e.target.getAttribute('id');
        var txt        = e.target.innerHTML;

     
        if(txt == 'zaznacz')
        {
            e.target.innerHTML = 'odznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {
                                    
                                         tab[g].dzieci[d].param1 = '1';
                                   
                            }   
                    }
                }

        }else
        {
            e.target.innerHTML = 'zaznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {
                                    
                                tab[g].dzieci[d].param1 = '0';
                                
                            }   
                    }
                }
        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));
        
    }


 


    const valChangeListener = (filedName, val, correct, msg) => {

       //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );               
    }


    const goNextNew = () => {
        console.log("goNext");               
    }


    




    
    if(tab == null)
        {
            setTab([]);
            getTab();
        

            return <div>
                ...
            </div>
        }


        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }


        var dlg_view = null;

     if(view != 'btn') 
     {

        //-----------------------------------------------------------

        console.log(filterParam);

        var rTab = new Array();


        for(var k=0; k<tab.length; k++) //petla po grupach..
        {
         

            var nDz = new Array();

            for(var d = 0; d < tab[k].dzieci.length; d++  )
            {
                var goAdd0 = true;
                var goAdd1 = true;
                var goAdd2 = true;
                var goAdd3 = true;
                var goAdd4 = true;
                var goAdd5 = true;


                var dz = tab[k].dzieci[d];


                if(filterParam.p_grupa_id != "_x_")
                {
                    goAdd0 = false;

                    if(tab[k].id == filterParam.p_grupa_id) goAdd0 = true;
                }


                if(filterParam.imie.length > 2)
                {
                    goAdd1 = false;

                    if(  dz.imie.toLowerCase().includes( filterParam.imie.toLowerCase() )  )
                    {
                            goAdd1 = true;
                    }
                }

                if(filterParam.nazwisko.length > 2)
                {
                        goAdd2 = false;
    
                        if(  dz.nazwisko.toLowerCase().includes( filterParam.nazwisko.toLowerCase() )  )
                        {
                                goAdd2 = true;
                        }
    
                }


                if( goAdd0 && goAdd1 && goAdd2 && goAdd3 && goAdd4 && goAdd5)
                {
                    nDz.push( tab[k].dzieci[d] );
                }
            }


            if(nDz.length > 0)
            {
                var rRow        = new Array();
                rRow["id"]      = tab[k].id;
                rRow["nazwa"]   = tab[k].nazwa;
                rRow["dzieci"]  = nDz;
    
                rTab.push(rRow);
            }
                       

        }

        //-----------------------------------------------------------




        var dlg_view =  (

            <div className="dlg_window dlg_type_xxx shadowx">
    
                    <div className="dlg_title">
                         Wybierz dzieci
                    </div>
    



                    <div className="table_filter">
                      

                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupaE   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 


                            <div className="filter_controll">   
                                        <label>Imię dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.imie}   valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "}   />
                           </div>  

                            <div className="filter_controll">   
                                        <label>Nazwisko dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "}   />
                            </div> 

                            <br/>



                    </div>
    




                    <div className="dlg_content_x">
    
    
                                      <div className="xselect_multi">
                                        {
                                            rTab.map( (gr, gi) => {
                                                return <div >

                                                     {
                                                          maxKids != 1 &&
                                                         <strong>{gr.nazwa} <sup className="link_color"  id={gr.id} onClick={selectAll}>zaznacz</sup>   </strong>
                                                     }
                                                     
                                                     
                                                     <ul>
                                                            {
                                                                gr.dzieci.map( (dz, di) => {

                                                                      //  var um = "";
                                                                      //  if(dz.umowa.length > 2) um = ", umowa: "+dz.umowa+" ";

                                                                        var css = '';

                                                                        if(dz.param1 == '1') css ="selected";

                                                                        return <li className={css}>
                                                                            <div className="xselect_t_content"  p_grupa_id={gr.id} p_dziecko_id={dz.id} onClick={goSelect}>
                                                                                { dz.nazwisko + " " + dz.imie    }
                                                                            </div>
                                                                            </li>
                                                                } ) 

                                                            }
                                                     </ul>
                                                     
                                                </div>
                                            } )
                                        }
                                      </div>  
    
                                        <br/>    
                                        <br/>   
    
                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>
    
                    </div>
    
                
            </div>
    );

    }
   
    
    var info = '';
    var ilosc = null;


 

    if(tabSelected.length == 0)
    {
        info = <div onClick={changeView} className="link_bad">Nie wybrano żadnego dziecka</div>; ;
    }else
    {
            ilosc = <div>
                <strong>wybranych dzieci: {tabSelected.length}</strong>
            </div>
    }


    if(props.info != undefined)
        {
            info = props.info;  
        }

    var titleX = "wyberz dzieci";
    if(props.max != undefined && props.max == 1)
    {
        titleX = "wyberz dziecko";  
    }

    
    return  <div>

                <br/>
                <div className="btn"    onClick={changeView} >{titleX}</div> 

                <div className="xselect">
                    {ilosc}
                 
                        {
                            tabSelected.map( (r, ix) => {
                                return <div className="xselect_item" onClick={changeView}>
                                        <div className="xselect_t_content">
                                           {r.nazwisko} {r.imie} 
                                        </div>
                                    </div>
                            } )
                        }

                        {info}

                        
                </div>


                {dlg_view} 
           </div>
}



export default InputKidsMulti;